module.exports = __webpack_public_path__ + "img/TurningStool3.992f0951.jpg";